import axios from "../axios-auth";

export const machineTypeService = {
    getMachineTypeList,
    saveMachineType,
    getMachineTypeDetail,
    getMachineTypeByStatus,
}

function getMachineTypeList(searchParams, page, size, sortBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }
    let params = {
        page: page,
        size: size,
        sort: sortBy
    }

    if (searchParams.code) {
        params["code"] = searchParams.code;
    }
    if (searchParams.name) {
        params["name"] = searchParams.name;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }

    return axios.get("/auth/machine-types", { params });
}

function saveMachineType(machineType) {
    if (!machineType.id) {
        // new
        return axios.post("/auth/machine-type", machineType);
    } else {
        // edit
        return axios.put("/auth/machine-type", machineType);
    }
}

function getMachineTypeDetail(id) {
    return axios.get("/auth/machine-type/" + id);
}

function getMachineTypeByStatus(status) {
    return axios.get("/auth/machine-types-by-status/" + status);
}